export default "__VITE_ASSET__DWUNzi3X__"